import React from "react";
import authService from "./AuthService";
import config, { getApiUrl } from "./config";
import toast from "react-hot-toast";
import {Client} from "./Clients";

type ClientFormProps = {};

type ClientFormState = {
    newClientId: string;
    newClientName: string;
    newClientEditor: string;
    newClientMetadata: string;
    newClientSecret: string;
};

class ClientForm extends React.Component<ClientFormProps, ClientFormState> {
    constructor(props: ClientFormProps) {
        super(props);
        this.state = {
            newClientId: "",
            newClientName: "",
            newClientEditor: "",
            newClientMetadata: "",
            newClientSecret: ""
        };
    }

    handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        this.setState({ [name]: value } as Pick<ClientFormState, keyof ClientFormState>);
    }

    createNewClient = () => {
        let body: any = {
            name: this.state.newClientName,
            editor: this.state.newClientEditor,
            metadata: this.state.newClientMetadata,
            client_secret: this.state.newClientSecret
        }
        console.log(body);        
        fetch(getApiUrl() + "/v1/client/" + this.state.newClientId, {
            "method": "POST",
            headers: [
                ["Content-Type", "application/json"],
                ["Accept", "application/json"],
                ["Authorization", authService.authHeader()]
            ],
            body: JSON.stringify(body)
        }).then((res) => {
                if (!res.ok) {
                    throw new Error("Failed to create client");
                }
                return res.json() as Promise<Client>
            })
            .then((client) => {
                toast.success("Client created successfully");
                this.setState({
                    newClientId: "",
                    newClientName: "",
                    newClientEditor: "",
                    newClientMetadata: "",
                    newClientSecret: ""
                });
            })
            .catch(() => {
                toast.error("Failed to create client");
            });
    }

    handleSubmit = () => {
        this.createNewClient();
    }

    render() {
        return (
            <div className="New-client-form">
                <input type="text" placeholder="ID" value={this.state.newClientId} onChange={this.handleInputChange} name="newClientId" />
                <input type="text" placeholder="Name" value={this.state.newClientName} onChange={this.handleInputChange} name="newClientName" />
                <input type="text" placeholder="Editor" value={this.state.newClientEditor} onChange={this.handleInputChange} name="newClientEditor" />
                <input type="text" placeholder="Metadata" value={this.state.newClientMetadata} onChange={this.handleInputChange} name="newClientMetadata" />
                <input type="text" placeholder="Secret" value={this.state.newClientSecret} onChange={this.handleInputChange} name="newClientSecret" />
                <button onClick={this.handleSubmit}>Create</button>
            </div>
        );
    }
}

export default ClientForm;